import { BucketFormikInput } from 'Src/types/widget-helpers';
import React from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { t } from 'Src/i18n';
import { ID_MODAL_HEADER__BE__PROMO_CODE } from 'Components/utils/identifiers/constants';
import { Button } from 'Components/frameworks/button/Button';
import { Modal } from 'Components/frameworks/modal/Modal';
const CIEL_VALIDATOR = yup.string().required();
type PromoCodeProps = {
  codeCiel: string | null;
  setCodeCiel: (value: string | null) => void;
  applyPromoCode: (params: {
    promoCode: string;
    partnerId?: string;
    accessCode?: string;
  }) => Promise<void>;
};
export const PromoCodeModal = ({ codeCiel, setCodeCiel, applyPromoCode }: PromoCodeProps) => {
  return (
    <Modal
      ariaLabel={t('booking.summary.cielPopIn.title')}
      ariaLabelledby={ID_MODAL_HEADER__BE__PROMO_CODE}
      closeLabel={t('common.close')}
      onClose={() => setCodeCiel(null)}
      size="small"
    >
      <Formik
        initialValues={{
          partnerId: null,
          accessCode: null,
        }}
        onSubmit={({ partnerId, accessCode }) => {
          applyPromoCode({
            promoCode: codeCiel || '',
            partnerId,
            accessCode,
          });
          setCodeCiel(null);
        }}
      >
        {(formik) => (
          <div className="p-20" data-testid="PromoCodeModal-form">
            <div className="mb-20 font-bold" id={ID_MODAL_HEADER__BE__PROMO_CODE}>
              {t('booking.summary.cielPopIn.title')}
            </div>
            <div>
              <BucketFormikInput
                type="text"
                name="partnerId"
                label={t('booking.summary.cielPopIn.collectivityID')}
                validate={CIEL_VALIDATOR}
              />
            </div>
            <div className="mt-10">
              <BucketFormikInput
                type="text"
                name="accessCode"
                label={t('booking.summary.cielPopIn.password')}
                validate={CIEL_VALIDATOR}
              />
            </div>
            <Button
              className="mt-20"
              data-testid="PromoCodeModal-submit"
              isDisabled={!formik.isValid}
              onClick={formik.submitForm}
            >
              {t('booking.common.validate')}
            </Button>
            <div className="mt-15 text-14">{t('booking.summary.cielPopIn.legalInfo')}</div>
          </div>
        )}
      </Formik>
    </Modal>
  );
};
